import React, { useState, useEffect } from "react";
import { Row, Col, Form, Container } from "react-bootstrap";
import { connect } from "react-redux";
import _ from "lodash";
import { } from "./salaryAction";
import Spinner from "react-bootstrap/Spinner";
import Select from "react-select";
import { Link } from "react-router-dom";
import { GetSalaryWithEmpIDApi } from "./salaryAction";
import { GetActiveEmployeeApi } from "../employee/employeeAction";
import { appendNonSignificantZeros } from "../../../../../global/globalFunctions";
import { setHeading } from "../../../accounts/account.actions";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';



const SalaryEditByEmpId = (props) => {
    const [employeeId, setEmployeeId] = useState("");
    const [employeeName, setEmployeeName] = useState();
    // const [employeeDataList, setEmployeeDataList] = React.useState("");


    const getEmployeeList = !_.isEmpty(props.activeEmployeeList) && props.activeEmployeeList.map((x) => {
        let data = { value: x._id, label: `${appendNonSignificantZeros(x.employeeName)}-${x.fatherName}-${x.cnic}` };
        return data
    })
    const handleChangeEmployee = (selectedOption) => {
        setEmployeeId(selectedOption.value);
        setEmployeeName(selectedOption.label);
        props.GetSalaryWithEmpIDApi(selectedOption.value);
    };

    useEffect(() => {
        props.GetActiveEmployeeApi();
        props.setHeading("Salary Edit")
    }, []);

    return (
        <>
            {props.isFetchingEmployeeData ? (
                <div className="loader-div">
                    <Spinner
                        variant="primary"
                        animation="border"
                        size="xl"
                        role="status"
                        aria-hidden="true"
                    />
                </div>
            ) : (
                <Container fluid>
                    <Row>
                        <Col>
                            <Form.Group className="mb-3" controlId="garana" >
                                <Form.Label><b>Select Employee *</b></Form.Label>
                                <Select
                                    // value={name}
                                    isDisabled={_.isEmpty(getEmployeeList)}
                                    placeholder="Select Employee"
                                    onChange={handleChangeEmployee}
                                    options={getEmployeeList}
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {employeeId === "" ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> EDIT SALARY </Button>
                        ) : (
                            <Link to={{ pathname: "/hr/salary/EditSalary" }}>
                                <Button variant="contained" endIcon={<SendIcon />} size="large"> EDIT SALARY  </Button>
                            </Link>
                        )}
                    </div>

                </Container>
            )}
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        GetActiveEmployeeApi: () => dispatch(GetActiveEmployeeApi()),
        GetSalaryWithEmpIDApi: (id) => dispatch(GetSalaryWithEmpIDApi(id)),
        setHeading: (data) => dispatch(setHeading(data)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    activeEmployeeList: state.EmployeeReducer.activeEmployeeList,
    isFetchingActiveEmployeeData: state.EmployeeReducer.isFetchingActiveEmployeeData,
});

export default connect(mapStateToProps, mapDispatchToProps)(SalaryEditByEmpId);
